export default __webpack_public_path__ + "static/media/bevel.3bae7485.svg";